import { mailToSupport } from '@issuemanager/constants';
import { Box, Link, Typography } from '@mui/material';
import { styled } from '@mui/system';
import { Trans } from 'react-i18next';

type Props = {
  title: string;
  description: string;
};

const StyledBox = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  text-align: center;
`;

export function TitleAndDescription({ title, description }: Props) {
  return (
    <StyledBox>
      <Typography fontWeight={600} fontSize={18} data-testid='general-title'>
        {title}
      </Typography>
      <Typography fontSize={16} data-testid='general-description'>
        <Trans
          i18nKey={description}
          components={{
            Link: <Link href={mailToSupport} />,
          }}
        />
      </Typography>
    </StyledBox>
  );
}
